import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import React from 'react';
import { Control, LocalForm, Errors } from 'react-redux-form';
import PropTypes, { number } from 'prop-types';
import Alert from '../../container/Alert';
import Comfirm from '../../container/Comfirm';
import Header from '../Header';
import { Helmet } from 'react-helmet';
import Footer from '../Footer';
import AlertTranslation from '../../elements/AlertTranslation';
// import Spinner from '../Snowflake/as/Spinner';

const messages = defineMessages({
  htmlHeader: {
    id: 'confirmation.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Comfirmation'
  },
  headerTitle: {
    id: 'translationapproval.header.title1',
    description: 'Page Header Title',
    defaultMessage: 'TRANSLATED CODE RELEASE APPROVAL'//'Commercial Translation Report Approval'
  },
  headerSubTitle: {
    id: 'translationapproval.header.subtitle1',
    description: 'Page Header Subtitle',
    defaultMessage:'Approve Translated Code Release'  // 'Approve Commercial Translation Report'
  }
});

const print = status => {
  if (status.payload) {
    // console.log(status.payload.response);
    return status.payload.response;
  }
};

const TranslationApproval = props => {
  const { intl } = props;

  return (
    <div className="preview page">
      <Helmet>
        <title>{intl.formatMessage(messages.htmlHeader)} - SHIFT</title>
      </Helmet>
      <Header
        title={intl.formatMessage(messages.headerTitle)}
        subtitle={intl.formatMessage(messages.headerSubTitle)}
        //steps={replaceID(steps, project.projectId)}
        icon="preview"
        //locale={this.props.locale}
      />
      {/*{this.state.show ? (*/}
          {/*<div   style={{display:"block"}}>*/}
            {/*<Spinner />*/}

          {/*</div>):null}*/}

      <AlertTranslation
        title={intl.formatMessage(messages.headerTitle)}
        message={print(props.status)}
      />

      <Comfirm
        pagetitle={intl.formatMessage(messages.headerTitle)}
        message={print(props.status)}
        nextpage="transApprovemsg"
      />
      <div className="main">
        <div
          className="panel"
          style={{
            width: '60%',
            padding: '40px',
            boxSizing: 'content-box',
            marginTop: '15px',
            display: 'block',
            alignContent: 'center',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >
          <LocalForm
            className="form"
            onSubmit={({ reponame, reference_id, quotation_id,translationRate,clientname,opportunity_num }) => {
              props.transSubmitHandler(reponame, reference_id, quotation_id,translationRate,clientname,opportunity_num);
            }}
          >
            <div
              style={{
                marginLeft: '3%'
              }}
            >
              <fieldset>
                <label style={{ textTransform: 'capitalize' }}>
                  <FormattedMessage
                    id="source.code.repository.name"
                    defaultMessage="Source Code Repository Name: "
                  />
                </label>
                {/* <label onClick={print(status)}>test</label> */}
                <Control.select
                  model=".reponame"
                  autoFocus
                  required
                  defaultValue={props.reponame}
                  onChange={props.getReferenceList}
                >
                  <option value="">Please select repository name</option>
                  {props.projectList.map(item => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                </Control.select>
              </fieldset>

              <fieldset>
                <label style={{ textTransform: 'capitalize' }}>
                  <FormattedMessage
                    id="translationapproval.reference.id"
                    defaultMessage="Reference ID: "
                  />
                </label>

                <Control.select
                  model=".reference_id"
                  autoFocus
                  required
                  value={props.reference_id}
                  onChange={props.getinfobyreferenceid}
                >
                  <option value="">Please select reference id</option>
                  {props.refrenceidList.map(item => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                </Control.select>
              </fieldset>
              {/* <fieldset>
                <label style={{ textTransform: 'capitalize' }}>
                  <FormattedMessage
                    id="translationapproval.reference.id1"
                    defaultMessage="Quotation ID: "
                  />
                </label>
                <Control.text
                  model=".quotation_id"
                  value={props.quotation_id}
                  disabled={true}
                />
              </fieldset> */}
              <fieldset>
                <label style={{ textTransform: 'capitalize' }}>
                  Client/Project Name:
                </label>
                <Control.text
                  model=".clientname"
                  value={props.clientname}
                  disabled
                />
              </fieldset>

              <fieldset>
                <label style={{ textTransform: 'capitalize' }}>
                  {/* FinancialForce ID: */}
                  Opportunity Number:
                </label>
                <Control.text
                  model=".financialForceId"
                  value={props.opportunity_num}
                  disabled
                />
              </fieldset>
              <fieldset>
                <label style={{ textTransform: 'capitalize' }}>
                  Translation Rate:
                </label>
                <Control.text
                  model=".translationRate"
                  value={props.translationRate}
                  disabled
                />
              </fieldset>
              <fieldset>
                <label style={{ textTransform: 'capitalize' }}>
                  Total Cost
                </label>
                <Control.text
                  model=".totalCost"
                  value={props.totalCost}
                  disabled
                />
              </fieldset>
              <div className="button-container" style={{ textAlign: 'center' }}>
                <button
                  className="button"
                  style={{ marginRight: '40px' }}
                  type="button"
                  onClick={() => props.clickBackHandler()}
                >
                  <FormattedMessage
                    id="run-assessment.back.button.name"
                    defaultMessage="Back"
                  />
                </button>
                <button
                  className="button"
                  style={{ marginRight: '40px' }}
                  type="button"
                  onClick={() => props.downloadHandler()}
                >
                  View Translation Report
                </button>
                <button className="button" type="submit">
                  <FormattedMessage
                    id="submit.button.name1"
                    defaultMessage="approve"
                  />
                </button>
              </div>
            </div>
          </LocalForm>
        </div>
      </div>
      <Footer />
    </div>
  );
};

TranslationApproval.propTypes = {
  transSubmitHandler: PropTypes.func.isRequired
};

export default injectIntl(TranslationApproval);



// WEBPACK FOOTER //
// ./src/components/views/TranslationApproval/index.js